import React, { useState } from "react";
import Cart from "./Cart";

import { checkInventory, getItem } from "../../api/giftshop";
import Loading from "../assets/Loading";

const development =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

// const development = false;

export const ShippingRanges = development
  ? {
        SO5FCDIGONEPHKXQE26D7TNG: { min: 0.0, max: 1.0 },
        VA2SBHMMWBEK4UX7UZCUJLAP: { min: 1.0, max: 5.0 },
    }
  : {
      SO5FCDIGONEPHKXQE26D7TNG: { min: 0, max: 0.5 },
      XZ3LMRGCFSTPQHAOVRKORUWG: { min: 0.6, max: 1.0 },
      VA2SBHMMWBEK4UX7UZCUJLAP: { min: 1.1, max: 2.0 },
      C7GKBNL3CA362TIMO6QYJBID: { min: 2.1, max: 3.0 },
      TNQPAERIUHOTGTKWWLHCHV6E: { min: 3.1, max: 4.0 },
      "4ISMPX5A3S6PTGRGNBB6YCZB": { min: 4.1, max: 5.0 },
      VRJFDFXQHCM7Z7H7ZYEUPN44: { min: 5.1, max: 100 },
    };

export const ShippingCustomWeight =
  development ? "Square:cb98ff15-47bd-4a7c-8d77-ed3fc33021a6" : "Square:099886ec-cf62-4821-9c88-d03c5e84c1c0";

export const getShippingItemByWeight = (shippingOptions, weight) => {
  var shippingItem = null;

  console.log(`Weight: ${weight}`);
  console.log(shippingOptions);
  Object.keys(shippingOptions).map((key) => {
    if (shippingOptions[key] && shippingOptions[key].shipping_range) {
      if (
        weight >= shippingOptions[key].shipping_range.min &&
        weight <= shippingOptions[key].shipping_range.max
      ) {
        shippingItem = shippingOptions[key];
      }
    }
  });

  if (shippingItem != null) {
    console.log("Max Shipping Already Found");
    console.log(shippingItem);
    shippingItem.itemData = shippingItem.item_data;
    shippingItem.itemData.variation = shippingItem.itemData.variations[0];
    shippingItem.itemData.variation.qty = 1;
  } else {
    Object.keys(shippingOptions).map((key) => {
      console.log("Finding Min Shipping");
      console.log(key);
      console.log(shippingOptions[key]);
      if (shippingOptions[key] && shippingOptions[key].shipping_range) {
        if (
          shippingItem == null ||
          shippingItem.shipping_range.min <
            shippingOptions[key].shipping_range.min
        ) {
          shippingItem = shippingOptions[key];
        }
      }
    });
    console.log("Getting Max Shipping");
    console.log(shippingItem);
    shippingItem.itemData = shippingItem.item_data;
    shippingItem.itemData.variation = shippingItem.itemData.variations[0];
    shippingItem.itemData.variation.qty = 1;
  }

  console.log("Shipping:");
  console.log(shippingItem);
  return shippingItem;
};

export const getHeaviestShippingOption = (shippingItems) => {
  // Turn Shipping Items into Array
  shippingItems = Object.keys(shippingItems).map((key) => shippingItems[key]);
  console.log(shippingItems);

  // Filter our items with no custom attributes
  shippingItems = shippingItems.filter(
    (item) =>
      item.itemData.custom_attribute_values != null &&
      item.itemData.custom_attribute_values[ShippingCustomWeight] != null
  );

  console.log(shippingItems);
  var heaviestItem = {};
  if (shippingItems.length > 0) {
    heaviestItem = shippingItems.reduce(function (prev, current) {
      var prevWeight = parseFloat(
        prev.itemData.custom_attribute_values[ShippingCustomWeight].number_value
      );
      var currentWeight = parseFloat(
        current.itemData.custom_attribute_values[ShippingCustomWeight]
          .number_value
      );
      return prevWeight > currentWeight ? prev : current;
    });
    console.log(
      heaviestItem.itemData.custom_attribute_values[ShippingCustomWeight]
        .number_value
    );
    return heaviestItem.itemData.custom_attribute_values[ShippingCustomWeight]
      .number_value;
  }
  return 0;
};

export const CategoryItem = (props) => {
  return (
    <div
      key={props.category.id}
      className={`category-item ${
        props.selected ? "category-item-selected" : ""
      }`}
      onClick={() =>
        props.onSetCategory({
          ...props.category.category_data,
          id: props.category.id,
        })
      }
    >
      {props.selected ? `> ` : ""}
      {props.category.category_data.name}
    </div>
  );
};

export const CatelogItem = (props) => {
  const itemData = props.item.item_data;
  itemData.image = props.images.length > 0 ? props.images[0] : "";
  return (
    <div
      id={props.item.id}
      className="item-container"
      onClick={() => props.onItemSelected(props.item)}
    >
      <div
        className="item-image"
        style={{
          "--src": `url(${
            props.images.length > 0
              ? props.images[0]
              : "/assets/llama-placeholder.png"
          })`,
        }}
      />
      <div className="item-name">{itemData.name}</div>
      <span className="item-price">
        $
        {itemData.variations.map((v) => {
          return v.item_variation_data.price_money != null
            ? v.item_variation_data.price_money.amount
            : "--";
        })[0] / 100.0}
      </span>
    </div>
  );
};

export const CurrentCatalogItem = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [inventory, setInventory] = useState(0);
  const [qty, setQty] = useState(1);
  const [variation, setVariation] = useState(
    props.item.item_data.variations[0]
  );
  const [image, setImage] = useState("/assets/llama-placeholder.png");
  const [images, setImages] = useState([]);
  const itemData = props.item.item_data;

  React.useEffect(() => {
    console.log(props.variations);
    setIsLoading(true);
    if (props.item) {
      setImages(getItemsImages(props.item, props.images));
      let foundImages = getItemsImages(props.item, props.images);
      if (foundImages.length > 0) {
        setImage(foundImages[0]);
      } else {
        setImage("/assets/llama-placeholder.png");
      }
      checkInventory(props.item.item_data.variations[0].id, (result) => {
        setInventory(parseInt(result[0].quantity));
        setIsLoading(false);
      });

      getItem(props.item.item_data.variations[0].id, (result) => {
        console.log(result);
      });
    }
  }, [props.item]);

  const onVariationUpdated = (variationId) => {
    let newVariation = itemData.variations.find((v) => v.id == variationId);

    // Check for Images
    // let foundImages = getItemsImages(newVariation, props.images);
    // if (foundImages.length > 0) {
    //   setImage(foundImages[0]);
    // } else {
    //   setImage("/assets/llama-placeholder.png");
    // }

    // setImages(foundImages);

    setVariation(newVariation);

    setIsLoading(true);
    checkInventory(variationId, (result) => {
      setInventory(parseInt(result[0].quantity));
      setIsLoading(false);
    });
  };

  return (
    <div className="item-container-selected-overlay">
      <div id={props.item.id} className="item-container-selected">
        {isLoading ? <Loading /> : <></>}
        <span
          className="close-dialog-button"
          onClick={() => props.onClose(null)}
        >
          X
        </span>
        <div className="item-selected-sub-container">
          <div
            className="item-image"
            style={{
              "--src": `url(${image})`,
            }}
          />
          <CatalogItemImages images={images} onImageSelected={setImage} />
        </div>
        <div className="item-selected-sub-container">
          <div className="item-name">{itemData.name}</div>
          <span className="item-price">
            $
            {itemData.variations.map((v) => {
              return v.item_variation_data.price_money.amount;
            })[0] / 100.0}
          </span>
          <span className="item-description">{itemData.description}</span>
          <ItemVariations
            variations={itemData.variations}
            onVariationSelected={(e) => {
              console.log(e.target.value);
              onVariationUpdated(e.target.value);
            }}
          />
          <div className="item-qty-container">
            <span className="item-qty-label">
              Quantity (Max: {inventory}):{" "}
            </span>
            {inventory == 0 ? (
              <>Out Of Stock</>
            ) : (
              <>
                <input
                  className="item-qty"
                  type="number"
                  min={1}
                  max={inventory}
                  value={qty}
                  onChange={(e) => {
                    console.log(e.target.value);
                    if (e.target.value > inventory) {
                      setQty(inventory);
                    } else {
                      setQty(e.target.value);
                    }
                  }}
                />
              </>
            )}
          </div>
          <div
            className="purple-button"
            onClick={() => {
              if (inventory > 0) {
                props.onAddedToCart({
                  ...props.item,
                  imageData: image,
                  variation: variation,
                  qty: qty,
                  inStock: inventory,
                });
                props.onClose(null);
              } else {
                alert("Item is Out Of Stock!");
              }
            }}
          >
            Add to Cart
          </div>
        </div>
      </div>
    </div>
  );
};

const ItemVariations = (props) => {
  return (
    <div className="">
      <span className="item-variation-label">Options: </span>
      <select
        className="item-variations-select"
        onChange={props.onVariationSelected}
      >
        {props.variations.map((v) => {
          if (v.item_variation_data.pricing_type == "FIXED_PRICING") {
            return (
              <option value={v.id}>
                {`${v.item_variation_data.name}: $${
                  v.item_variation_data.price_money.amount / 100.0
                }`}
              </option>
            );
          }
        })}
      </select>
    </div>
  );
};

const CatalogItemImages = (props) => {
  if (props.images.length > 0) {
    return (
      <div className="item-gallery-container">
        {props.images.map((image) => {
          return (
            <div
              className="item-image-thumb"
              style={{
                "--src": `url(${image})`,
              }}
              onClick={() => props.onImageSelected(image)}
            />
          );
        })}
      </div>
    );
  } else {
    return <div></div>;
  }
};

export const getItemsImages = (item, images) => {
  console.log("Getting Images");
  console.log(item);
  var item_images = [];
  if (item.image_id != null) {
    item_images.push(images.find((i) => i.id == item.image_id).image_data.url);
  } else if (item.item_data && item.item_data.ecom_image_uris != null) {
    item_images = item.item_data.ecom_image_uris;
  } else if (item.item_data && item.item_data.image_ids) {
    item_images = item.item_data.image_ids.map((id) => {
      return images.find((i) => i.id == id).image_data.url;
    });
  }
  console.log(item_images);
  return item_images;
};

export const StatusBar = (props) => {
  return (
    <div className="status-bar">
      <div className="current-category-label">
        {props.currentCategory != null
          ? props.currentCategory.name
          : "Select A Category"}
      </div>
      <Cart items={props.cartItems} shippingItems={props.shippingItems} />
    </div>
  );
};
